import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const EmptyTableTitle = styled(Typography)``;

const EmptyTableDescription = styled(Typography)`
  margin-top: 8px;
  text-align: center;
  width: 400px;
`;

const EmptyTableContentBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const EmptyTableContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 80px 0;

  ${Button.S.Button} {
    margin-top: 16px;
  }
`;

export { EmptyTableContent, EmptyTableContentBody, EmptyTableDescription, EmptyTableTitle };
